import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deleteProject, getProjects, ProjectSummary } from '../services/adminApi';

const ProjectsPage = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState<ProjectSummary[]>([]);
  const [error, setError] = useState<string | null>(null);

  const loadProjects = async () => {
    setError(null);
    try {
      const items = await getProjects();
      setProjects(items);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('pages.projectsLoadFailed', 'Failed to load projects.'));
    }
  };

  useEffect(() => {
    void loadProjects();
  }, []);

  const handleDelete = async (id: string) => {
    if (!confirm(t('pages.projectsDeleteConfirm', 'Delete this project?'))) return;
    try {
      await deleteProject(id);
      await loadProjects();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('pages.projectsDeleteFailed', 'Delete failed'));
    }
  };

  return (
    <div className="page-grid">
      <div className="section-heading">
        <h2>{t('pages.projectsTitle')}</h2>
        <p>{t('pages.projectsDescription')}</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="admin-panel">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0 }}>{t('pages.projectsTitle')}</h3>
          <Link to="/admin/projects/new" className="btn btn-primary">
            {t('pages.projectsNew', 'New project')}
          </Link>
        </div>

        <div style={{ display: 'grid', gap: '1rem', marginTop: '1rem' }}>
          {projects.map((project) => (
            <div key={project.id} className="admin-panel" style={{ padding: '1rem' }}>
              <h4 style={{ margin: 0 }}>{project.title}</h4>
              <p style={{ margin: '0.25rem 0', color: '#475569' }}>{project.location}</p>
              <p style={{ margin: '0.25rem 0', fontWeight: 600 }}>{project.status}</p>
              <div className="admin-actions" style={{ marginTop: '1rem' }}>
                <Link to={`/admin/projects/${project.id}`} className="btn btn-secondary">
                  {t('common.edit', 'Edit')}
                </Link>
                <button type="button" className="btn btn-ghost" onClick={() => handleDelete(project.id)}>
                  {t('common.delete', 'Delete')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;
